import { Box, BoxProps } from '@mui/material'
import React from 'react'

import gremlinLogo from 'assets/gremlin-logo-primary.svg'
import Image from 'components/common/Image'

export const GremlinLogo: React.FC<BoxProps> = ({ ...rest }) => {
  return (
    <Box
      sx={(muiTheme) => ({
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'start',
        padding: muiTheme.spacing(0)
      })}
      {...rest}
    >
      <Image
        alt="Gremlin"
        css={{
          height: 30
        }}
        src={gremlinLogo}
      />
    </Box>
  )
}
